import { GET, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/domain-configuration${endpoint}`;
};

export const getAllSmsTemplates = (token) => {
  const endpoint = getEndpointWithPrefix('');
  return GET(endpoint, token);
};

export const updateSmsTemplate = (payload, token) => {
  const endpoint = getEndpointWithPrefix('/update');
  return PUT(endpoint, payload, token);
};
